<template>
    <div class="solution-box w1420">
        <p class="title"><span class="special-title">一带一路：连接未来，共创繁荣</span></p>
        <div class="solutions">
            <router-link tag="a" v-for="(item,index) in dataList"
                :to="{name:'successfulCaseDetail',query:{id:item.id}}"
                :key="'item-'+index"
                class="solution-item">
                <div class="img-box">
                    <div class="mask"></div>
                    <img :src="urlPath+item.imgName" alt="">
                </div>
                <div class="text-box" :key="'text-'+index">
                    <div class="category">{{item.title}}</div>
                    <router-link tag="div" :to="{name:'newsDetails',query:{id:item.id}}" class="read-more"><span>更多</span><span>></span></router-link>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>

export default {
    name: "RecommendSolution",
    data(){
        return{
            urlPath:this.url,
            dataList:[]
        }
    },
    mounted(){
        let vm=this;
        this.$ajax({
            method: 'get',
            url:vm.dataURL('findRecommendSolutionList')
        }).then((res)=>{
            vm.dataList=res.data.data;
        });
    }
}
</script>

<style lang="scss" scoped>
    .solution-box{
        height:auto;
        margin: 0 auto;
        .xnxg{
            display: inline-block;
            width: 150px;
            height: 55px;
            margin-right: 10px;
            background-size: 100% 100%;
            background-image: url("../../../static/images/xiniuxiaoge.png");
            animation: fadeInLeft 1s;
        }
        .title{
            padding-top: 40px;
            text-align: center;
            font-size: 36px;
            letter-spacing: 2px;
        }
        .special-title{
            color: $fontColor;
        }
    }
    .solutions{
        height:auto;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        padding: 10px;
        margin: 0 auto;
        flex-wrap: wrap;
    }
    .solution-item {
        height: 280px;
        width: 30%; /* 每个项目平均分配空间 */
        margin: 10px; /* 内边距 */
        box-sizing: border-box; /* 防止内边距影响宽度 */
        // text-align: center; /* 文字居中 */
        color: #fff;
        text-decoration: none;
        display: block;
        overflow: hidden;
        position: relative;
        .img-box{
            position: relative;
            width:100%;
            height:100%;
        }
        .mask{
            position: absolute;
            visibility: visible;
            opacity: 1;
            height: 70%;
            width: 100%;
            content: "";
            background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 70%);
            display: block;
            top: auto;
            bottom: 0;
        }
        img{
            width:100%;
            height:100%;
        }
        .text-box {
            width: 100%;
            height: auto;
            position: absolute;
            left: 0;
            color: #fff;
            text-align: left;
            -webkit-transition: all 0.5s;
            transition: all 0.5s;
            z-index: 4;
            bottom: 0;
            padding: 15px;
            font-size: 14px;
            padding: 25px 30px;
            bottom: -50px;
            .category {
                margin-bottom: 12px;
                font-size: 1.2em;
                line-height: 1.4em;
                font-weight: bold;
            }
            .read-more {
                position: relative;
                display: inline-block;
                text-decoration: none;
                vertical-align: middle;
                font-size: 1.1em;
                line-height: 1.5em;
                outline: none;
            }
        }
    }
    .solution-item:hover .text-box {
        bottom: 0;
    }
    .solution-item:hover .text-box .read-more {
        visibility: visible;
        opacity: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/recommendSolution.vue